import { render, staticRenderFns } from "./TicketDetailSummary.vue?vue&type=template&id=68e23e2e&scoped=true"
import script from "./TicketDetailSummary.vue?vue&type=script&lang=js"
export * from "./TicketDetailSummary.vue?vue&type=script&lang=js"
import style0 from "./TicketDetailSummary.vue?vue&type=style&index=0&id=68e23e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e23e2e",
  null
  
)

export default component.exports